import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-me-gusta-producto',
  templateUrl: './me-gusta-producto.component.html',
  styleUrls: ['./me-gusta-producto.component.scss'],
})
export class MeGustaProductoComponent implements OnInit {
  @Input() megusta: boolean;
  constructor() { 
    if (this.megusta==undefined || this.megusta == null){
      this.megusta = false;
    }
  }

  ngOnInit() {}

  like(){
    this.megusta = !this.megusta;
  }
}
